import type { Airflow } from '@aviata/platform-types';
import { isAncillary } from '../types/guards';

export const getSeatMapPrice = (
  productsList: Airflow.Order.Entity['products'],
) => {
  const seats = productsList.filter(
    product =>
      isAncillary(product) && product.type === 'airflow.ancillary.seat',
  );

  if (seats.length !== 0) {
    return seats.reduce((price, baggage) => {
      return price + Number(baggage.total);
    }, 0);
  }
  return null;
};
